// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { pickUpAddressStyles } from "@eisinc/Overrides/Widgets/CheckoutShipping/PickUpAddress";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { css } from "styled-components";

pickUpAddressStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};

pickUpAddressStyles.headingGridItem = {
    css: css`
        display: flex;
        gap: 10px 20px;
        flex-wrap: wrap;
    `,
};

pickUpAddressStyles.headingText = {
    variant: "h4",
    css: css`
        margin-bottom: 0;
    `,
};

pickUpAddressStyles.findLocationLink = {
    typographyProps: {
        size: fontConfig.singleLinexSmall.size,
        lineHeight: fontConfig.singleLinexSmall.lineHeight,
    },
};

pickUpAddressStyles.selectedLocationGridItem = {
    css: css`
        display: flex;
        flex-direction: column;
        margin-top: 4px;
    `,
};

pickUpAddressStyles.selectedLocationName = {
    size: fontConfig.small.size,
    lineHeight: fontConfig.small.lineHeight,
};
